import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-achievements-non-academics',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class AchievementsNonAcademicsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
